import { Archive, ArchiveRestore, Clock3, FileText, MessageCircle, Pencil, Trash2 } from 'lucide-react'

import type { DocumentRecord } from '../../shared/types'

interface DocumentCardProps {
  document: DocumentRecord
  onOpen: () => void
  onRename: (event: React.MouseEvent<HTMLButtonElement>) => void
  onArchive: () => void
  onDelete: (event: React.MouseEvent<HTMLButtonElement>) => void
}

function summary(content: string): string {
  const plain = content.replace(/[#>*_`\-[\]]/gu, ' ').replace(/\s+/gu, ' ').trim()
  return plain || '这是一张等待落笔的新纸。'
}

export function DocumentCard({ document, onOpen, onRename, onArchive, onDelete }: DocumentCardProps) {
  const updated = new Intl.DateTimeFormat('zh-CN', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }).format(
    new Date(document.updatedAt),
  )
  return (
    <article className="document-card">
      <div className="card-topline">
        <span className="file-chip"><FileText size={15} />v{document.version}</span>
        <div className="card-actions">
          <button type="button" onClick={onRename} aria-label={`重命名“${document.title}”`} title="重命名"><Pencil size={16} /></button>
          <button type="button" onClick={onArchive} aria-label={`${document.archived ? '恢复' : '归档'}“${document.title}”`} title={document.archived ? '恢复' : '归档'}>
            {document.archived ? <ArchiveRestore size={16} /> : <Archive size={16} />}
          </button>
          <button type="button" onClick={onDelete} aria-label={`删除“${document.title}”`} title="删除"><Trash2 size={16} /></button>
        </div>
      </div>
      <button type="button" className="card-open" onClick={onOpen} aria-label={`打开“${document.title}”`}>
        <h2>{document.title}</h2>
        <p>{summary(document.content)}</p>
      </button>
      <footer>
        <span><Clock3 size={14} />{updated}</span>
        <span><MessageCircle size={14} />{document.commentCount ?? 0} 条留言</span>
      </footer>
    </article>
  )
}
